import { CustomContent, CustomContentType, IntentType, Message } from '../dataType';
import { useMessage, genMessageId } from './useMessage';
import { useConfig } from './useConfig';

import IntentDivider from '../components/custom-message/IntentDivider.vue';
import IntentionDivider from '../components/custom-message/IntentionDivider.vue';

let lastMessageIntent: IntentType | undefined;

export const isOtherMessage = (message: Message<any>) => message.type === 'custom';

export const genCustomMessage = <T>(content: CustomContent<T>): Message<CustomContent<T>> => {
  return {
    id: genMessageId(),
    userId: -1,
    avatar: '-1',
    status: 'success',
    content,
    type: 'custom'
  };
};

export const useCustomMessage = () => {
  const { intent } = useConfig();
  const { addMessage, deleteMessage, messages, subscribe, insertMessage } = useMessage();

  const getLastCustomMessage = (type?: CustomContentType) => messages.value.find(message => {
    if (!isOtherMessage(message)) {
      return false;
    }
    if (!type) {
      return true;
    }
    const content = message.content as CustomContent<any>;
    return content.type === type;
  });

  const subscribeForIntent = () => subscribe((message: Message<any> | Message<any>[]) => {
    // 多条消息不处理
    if (Array.isArray(message)) {
      return;
    }
    if (message.type === 'ai.sendText') {
      if (!lastMessageIntent) {
        lastMessageIntent = intent.value;
      }
      clearCustomMessage('change.intent');
      // 如果上一次意图和当前意图不一致则添加一个分割消息
      // 0914: 用户在底部输入框主动点击发送时才发送
      if (lastMessageIntent !== intent.value && message.inputType === 'sendInput') {
        insertMessage<CustomContent<IntentType>>(message.id, 'start', genCustomMessage({
          type: 'change.intent',
          component: IntentDivider,
          data: intent.value
        }));
        lastMessageIntent = intent.value;
      }
    }
  });
  
  const subscribeForIntention = () => subscribe((message: Message<any> | Message<any>[]) => {
    // 多条消息不处理
    if (Array.isArray(message)) {
      return;
    }
    if (message.type === 'ai.intentionBack') {
      insertMessage<CustomContent<IntentType>>(message.id, 'start', genCustomMessage({
        type: 'change.intention',
        component: IntentionDivider
      }));
    }
  });
  const clearCustomMessage = (type: CustomContentType) => {
    const last = getLastCustomMessage(type);
    if (last) {
      deleteMessage(last.id);
      clearCustomMessage(type);
    }
  };

  const addCustomMessage = <T>(content: CustomContent<T>, clear: boolean = false) => {
    if (clear) {
      clearCustomMessage(content.type);
    }

    const message = genCustomMessage(content);
    addMessage(message);
  };

  return {
    addCustomMessage,
    subscribeForIntent,
    subscribeForIntention
  };
};
